import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import PT from 'prop-types';
import RRPT from 'react-router-prop-types';
import imgAndroid from './images/android.png';
import imgGooglePlay from './images/google_play.png';
import imgIos from './images/ios.png';
import './index.scss';
// eslint-disable-next-line import/first
import {Toast} from 'antd-mobile';

class Home extends React.Component {
  state = {
    contactVisible: false,
  };

  hideContactAlert = () => {
    this.setState({
      contactVisible: false,
    });
  };

  showContactAlert = () => {
    this.setState({
      contactVisible: true,
    });
  };

  getYear = () => new Date().getFullYear();

  render() {

    return (
      <div className="HomeHuna">
        <Helmet>
          <title>Welcome to Huna</title>
          <style>{`body { background-color: #F9F6FF; }`}</style>
        </Helmet>

        {/* Header Section */}
        <header className="HomeHuna__header">
          <div className="HomeHuna__logo">
            <div className="HomeHuna__logoImg" />
            <div className="HomeHuna__logoText">Huna</div>
          </div>
          <div className="HomeHuna__welcomeText">
            <h1>Welcome to Huna</h1>
            {/* <p className="HomeHuna__slogan">Joyful, Fun, Energetic</p> */}
            <div className="HomeHuna__desc">
              Welcome to Huna, a brand-new social experience combining interaction, exploration, and tasks!
              <br />
              Say Hello to Them<br />
              Join lively chat rooms, interact with people from all over the world in real time, share joy, and make new friends!
              <br />
              Care for Sea<br />
              Complete fun “cleanup tasks” to protect the ocean, embrace the importance of environmental care, and explore the wonders of the underwater world!
              <br />
              Enjoy the Chat<br />
              Start conversations effortlessly, share life moments with others, and dive into meaningful stories.
              <br />
              Share, Connect<br />
              In Huna, sharing is the beginning of connection. Explore others' rooms and grow together with like-minded individuals.
              <br />
              Finding Yourself<br />
              Discover a better version of yourself with a personalized leveling system and badge rewards, and enjoy the satisfaction of continuous progress.
              <br />
              Huna is more than just a chat platform — it’s your ideal space to explore yourself and share happiness. Join now and embark on a unique social journey!
            </div>
          </div>
        </header>
        <div className="HomeHuna__whiteSeparator" />
        {/* Main Content Section */}
        <main className="HomeHuna__main">
          <div className="HomeHuna__downloadButtons">
            <button
              className="HomeHuna__downloadBtn"
              // onClick={() => { window.location.href = iOSDownloadUrl4X; }}
              onClick={() => Toast.info('Not yet open, please stay tuned')}
            >
              <img src={imgIos} alt="App Store" className="HomeHuna__downloadIcon" />
              AppStore
            </button>
            <button
              className="HomeHuna__downloadBtn"
              // onClick={() => { window.location.href = androidDownloadUrl4X; }}
              onClick={() => Toast.info('Not yet open, please stay tuned')}
            >
              <img src={imgGooglePlay} alt="Google Play" className="HomeHuna__downloadIcon" />
              Google Play
            </button>
            {/* <button */}
            {/*  className="HomeHuna__downloadBtn" */}
            {/*  // onClick={() => { window.location.href = directDownloadUrl4X; }} */}
            {/*  onClick={() => Toast.info('Not yet open, please stay tuned')} */}
            {/* > */}
            {/*  <img src={imgAndroid} alt="Android APK" className="HomeHuna__downloadIcon" /> */}
            {/*  Android APK */}
            {/* </button> */}
          </div>
          <div className="HomeHuna__appWrapper">
            {/* <Carousel images={images} /> */}
            <div className="HomeHuna__app" />
          </div>
        </main>

        {/* Footer Section */}
        <footer className="HomeHuna__footer">
          <div className="HomeHuna__footerLinks">
            <a href="https://huna.live/huna/about/userAgreement">User Agreement</a>
            <a href="https://huna.live/huna/about/privacyAgreement">Privacy Policy</a>
            <div
              className="HomeHuna__contact"
              onMouseLeave={this.hideContactAlert}
              onMouseEnter={this.showContactAlert}
            >
              Contact Us
              {this.state.contactVisible && (
                <div className="HomeHuna__contactDetails">
                  <p>Mail: report@huna.live</p>
                </div>
                )}
            </div>
          </div>
          <div className="HomeHuna__companyInfo">
            {`Raht Abbas · ${this.getYear()}`}
          </div>
        </footer>
      </div>
    );
  }
}

Home.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  history: RRPT.history.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  userAgent: PT.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  hostname: PT.string.isRequired,
};

Home.defaultProps = {};

export default connect(state => {
  const { env: { userAgent, hostname } } = state;
  return { userAgent, hostname };
})(Home);
